import { render, staticRenderFns } from "./ItemDetailHeartLayout.vue?vue&type=template&id=548988df&scoped=true"
import script from "./ItemDetailHeartLayout.vue?vue&type=script&lang=js"
export * from "./ItemDetailHeartLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548988df",
  null
  
)

export default component.exports